import CustomDashboard from '../../../Component/Dashboard/Custom/CustomDashboard'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../hooks/useAuth'
import { Container, Row, Col, Badge } from 'reactstrap'
import H4 from '../../../CommonElements/Headings/H4Element'

const Default = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  
  return (
    <div className='page-body'>
      <Container fluid>
        <div className="page-title">
          <Row>
            <Col xs="12">
              <H4 style={{ margin: 0, display: 'inline' }}>
                {t("Hola")}, {user?.name || user?.email || t("Usuario")}
              </H4>
              {user?.role && (
                <Badge 
                  color="primary" 
                  style={{ 
                    marginLeft: '10px',
                    fontSize: '0.875rem',
                    padding: '5px 10px'
                  }}
                >
                  {user.role.name}
                </Badge>
              )}
            </Col>
          </Row>
        </div>
      </Container>
      <CustomDashboard />
    </div>
  )
}

export default Default
